import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Paths, Urls } from "./../../constants/UrlConstants";
import Store from "./../../content/Store";
import Contentify from "../../content/Contentify";
import { setUnreadMessageCount } from "../../actions/inbox/InboxActions";
import { MessagesUpdateThreshold } from "../../constants/Constants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import SmartLink from "../shared/links/SmartLink";
import { ButtonConfig } from "../../constants/Constants";

export class InboxLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url:Urls.EngagementPortal[EPDomain_ROOT].messages
    };
  }
  handleCallback = (data) => {
    this.setState({ url: data });
};
  componentDidUpdate = (prevProps) => {
    if (
      this.hasThereBeenAnInteractionWithTheSite(prevProps) &&
      this.hasMessagesThresholdBeenExceeded()
    ) {
      this.props.setUnreadMessageCount(this.props.selectedPolicy);
    }
  };

  hasMessagesThresholdBeenExceeded = () =>
    Date.now() - this.props.lastRequestedTime > MessagesUpdateThreshold;

  hasThereBeenAnInteractionWithTheSite = (previousProps) =>
    previousProps.lastInteractionTime !== this.props.lastInteractionTime;

  render = () => {
    let iconClass = "icon-email";
    if (this.props.unreadMessageCount) {
      iconClass += " count-icon";
    }
    return (
      
       this.props.featureFlagEP === true ?
      (
        <>
        <EPQueryParams url={this.state.url} updatedURL={this.handleCallback}/>
        <SmartLink to={this.state.url} isExternalLink={true} isDisabled={this.props.IsInternalView} disableStyle={this.props.IsInternalView}>
        <i className={iconClass} data-count={this.props.unreadMessageCount} />
        <span className="hidden-sm-down" id={ButtonConfig.HomeIndcta_mol_hp_inbox}>{this.props.content.label}</span>
        </SmartLink>
        </>
      ) :
      (<Link to={Paths.InboxLoader} >
        <i className={iconClass} data-count={this.props.unreadMessageCount} />
        <span className="hidden-sm-down" id={ButtonConfig.HomeIndcta_mol_hp_inbox}>{this.props.content.label}</span>
      </Link>)     
    );
  };
}

InboxLink.content = Store.InboxLink;

export const mapStateToInboxLink = ({
  unreadMessagesReducer,
  policyReducer,
  networkStateReducer
}) => {
  return {
    unreadMessageCount: unreadMessagesReducer.unreadMessageCount,
    latestUnreadMessageId: unreadMessagesReducer.latestUnreadMessageId,
    lastRequestedTime: unreadMessagesReducer.lastRequestedTime,
    lastInteractionTime:
      networkStateReducer && networkStateReducer.lastInteractionTime,
    selectedPolicy: policyReducer.selectedPolicy,
    featureFlagEP : unreadMessagesReducer.featureFlagEP,
    IsInternalView: policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.IsInternalView,
  };
};

export default withRouter(
  connect(mapStateToInboxLink, { setUnreadMessageCount })(Contentify(InboxLink))
);
